import {useEffect, useState} from 'react'

import {useFormik} from 'formik'
import {Button, Container, Form as BootstrapForm, Modal} from 'react-bootstrap'
import * as Yup from 'yup'
import {toast} from 'react-toastify'

import {KTCard, KTCardBody, KTIcon} from '../../../_metronic/helpers'
import {PageTitle} from '../../../_metronic/layout/core'

import {useMutation, useLazyQuery} from '@apollo/client'
import {Spinner} from '../../components/Spinner'
import {useGetUser} from '../../hooks/useGetUser'
import {BreadcrumbJeisat} from '../../components/BreadcrumbJeisat'
import {hasPermission, parseId} from '../../helpers'
import {GET_ALL_TRANSPORTS} from '../../graphql/queries/getTransports'
import type {
  DataTransportCreate,
  EdgeTransport,
  IDataTransport,
} from '../../graphql/types/Transports'
import {CREATE_UPDATE_TRANSPORT} from '../../graphql/mutations/transportMutations'
import {ALL_PERMISSIONS} from '../../helpers/consts'

const validationSchema = Yup.object().shape({
  plate: Yup.string().required('El campo es obligatorio'),
  sizeVolco: Yup.string().required('El campo es obligatorio'),
  description: Yup.string(),
})

export const TransportPage = () => {
  const [gqlGetAllTransports, {data, loading, error, refetch}] = useLazyQuery<IDataTransport>(
    GET_ALL_TRANSPORTS,
    {
      fetchPolicy: 'no-cache',
    }
  )
  const [gqlCreateUpdateClient, {data: dataCreate, loading: loadingCreate, error: errorCreate}] =
    useMutation<DataTransportCreate>(CREATE_UPDATE_TRANSPORT)

  const [searchTerm, setSearchTerm] = useState('')
  const [showModalCreateUpdate, setShowModalCreateUpdate] = useState(false)
  const [idClientEdit, setIdClientEdit] = useState<null | string>(null)
  const [after, setAfter] = useState<string | null>(null)
  const [isPagination, setIsPagination] = useState(false)
  const [isSearch, setIsSearch] = useState(false)
  const [dataArr, setDataArr] = useState<EdgeTransport[]>([])

  const {/* idOrganization, */ user} = useGetUser()

  const formik = useFormik({
    initialValues: {
      plate: '',
      sizeVolco: '',
      description: '',
    },
    validationSchema,
    onSubmit: (values) => {
      // Aquí puedes realizar la acción con los datos enviados por el formulario
      /* console.log(values)
      if (!idOrganization) return */
      gqlCreateUpdateClient({
        variables: {
          input: {
            ...values,
            id: idClientEdit ? parseId(idClientEdit) : undefined,
            // organization: parseId(idOrganization),
          },
        },
      })
    },
  })

  useEffect(() => {
    const variables: {after: string | null; plate?: string} = {
      after,
    }
    if (searchTerm) {
      variables.plate = searchTerm
    }
    gqlGetAllTransports({
      variables,
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [after, searchTerm])

  useEffect(() => {
    if (error) {
      toast.error('error' + error.message)
    }
  }, [error])

  useEffect(() => {
    if (!data) return
    setIsSearch(false)
    if (isPagination) {
      setDataArr((prev) => [...prev, ...data.transportList.edges])
      return
    }
    setDataArr(data.transportList.edges)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data])

  useEffect(() => {
    if (!dataCreate) return
    if (dataCreate.transportCreateUpdate.transport?.id) {
      toast.success(`Volqueta ${idClientEdit ? 'actualizada' : 'creada'} con éxito`)
      setIsPagination(false)
      setAfter(null)
      refetch()
      setShowModalCreateUpdate(false)
      formik.resetForm()
    } else if (
      dataCreate?.transportCreateUpdate.errors &&
      dataCreate?.transportCreateUpdate.errors.length > 0
    ) {
      toast.error('Error: ' + dataCreate?.transportCreateUpdate.errors[0].messages)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataCreate])

  useEffect(() => {
    if (errorCreate) {
      toast.error('Error: ' + errorCreate.message)
    }
  }, [errorCreate])

  const handleClose = () => {
    setShowModalCreateUpdate(false)
  }
  const handleSubmitSearchName = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    const {name} = Object.fromEntries(new FormData(e.currentTarget))
    if (name.toString() === '') {
      setAfter(null)
      setSearchTerm('')
      return
    }
    if (name.toString().length < 3) return
    setSearchTerm(name.toString())
    setIsSearch(true)
  }
  if (loading && !isPagination && !isSearch) {
    return (
      <div>
        <PageTitle
          breadcrumbs={[
            {
              title: 'CMR',
              path: '/',
              isSeparator: false,
              isActive: false,
            },
            {
              title: '',
              path: '',
              isSeparator: true,
              isActive: false,
            },
          ]}
        >
          Lista de volquetas
        </PageTitle>
        <KTCard>
          <div style={{height: '40vh'}}>
            <KTCardBody className='py-4 d-flex align-items-center justify-content-center h-100'>
              <Spinner />
            </KTCardBody>
          </div>
        </KTCard>
      </div>
    )
  }
  const canterasList = dataArr

  const permissions = user?.tokenAuth.permissions ?? ['']

  return (
    <div>
      <BreadcrumbJeisat
        title='Lista de volquetas'
        breadcrumb={[
          {
            title: 'CRM',
            path: '/dashboard',
            isSeparator: false,
            isActive: false,
          },
          {
            title: '',
            path: '',
            isSeparator: true,
            isActive: false,
          },
        ]}
        isBtns
        children={
          <>
            {hasPermission(permissions, ALL_PERMISSIONS.PUEDE_AGREGAR_TRANSPORTE) ? (
              <Button
                onClick={() => {
                  setShowModalCreateUpdate(true)
                  setIdClientEdit(null)
                }}
                className='d-flex align-items-center gap-1'
              >
                <i className='fa fa-plus' /> Agregar volqueta
              </Button>
            ) : null}
          </>
        }
      />

      <KTCard>
        <div className='card-header border-0 pt-6'>
          <div className='card-title'>
            {/* begin::Search */}
            <form onSubmit={handleSubmitSearchName}>
              <div className='d-flex align-items-center position-relative my-1'>
                <KTIcon iconName='magnifier' className='fs-1 position-absolute ms-6' />
                <input
                  type='search'
                  data-kt-user-table-filter='search'
                  className='form-control form-control-solid w-250px ps-14'
                  placeholder='Buscar volqueta'
                  name='name'
                />
              </div>
            </form>
            {/* end::Search */}
          </div>
          {loading && isSearch && <Spinner size='20px' />}
          {/* begin::Card toolbar */}
          {/*  <div className='card-toolbar'>
            {/* begin::Group actions
            <UsersListToolbar />
            {/* end::Group actions 
          </div> */}
          {/* end::Card toolbar */}
        </div>
        <KTCardBody className='py-4'>
          <div className='table-responsive'>
            {canterasList.length > 0 ? (
              <table
                id='kt_table_users'
                className='table align-middle table-row-dashed fs-6 gy-5 dataTable no-footer'
              >
                <thead className='fw-bold'>
                  <tr className='text-start text-gray-900 fw-bold fs-7 text-uppercase gs-0'>
                    <th>#</th>
                    <th>Placa</th>
                    <th className='text-center'>Capacidad máxima</th>
                    <th>Descripción</th>
                    <th />
                  </tr>
                </thead>
                <tbody className='text-gray-700'>
                  {canterasList.map(({node}, idx) => (
                    <tr key={node.id}>
                      <td className='text-muted'>{idx + 1}</td>
                      <td className='text-uppercase'>{node.plate}</td>
                      <td className='text-center'>{node.sizeVolco}</td>
                      <td>{node.description}</td>
                      <td>
                        <button
                          className='border-0 p-0 m-0 bg-transparent me-4 hover-bg-color-dark text-secondary'
                          onClick={() => {
                            setIdClientEdit(node.id)
                            setShowModalCreateUpdate(true)
                            formik.setValues({
                              description: node.description,
                              plate: node.plate,
                              sizeVolco: node.sizeVolco,
                            })
                          }}
                          title='Editar'
                        >
                          <i className='fa fa-pencil' style={{color: 'inherit'}} />
                        </button>
                        {/* <button
                          className='border-0 p-0 m-0 bg-transparent hover-bg-color-dark text-secondary'
                          onClick={() => setIdCanteraEdit(node.id)}
                          title='Ver'
                        >
                          <i className='fa fa-eye' style={{color: 'inherit'}} />
                        </button> */}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            ) : (
              <div
                className='d-flex text-center w-100 align-items-center justify-content-center'
                style={{height: '30vh'}}
              >
                <div>No hay volquetas registradas</div>
              </div>
            )}
          </div>
          {loading && isPagination && (
            <div className='d-flex justify-content-center align-items-center mt-2'>
              <Spinner size='24px' />
            </div>
          )}
          {data?.transportList.pageInfo.hasNextPage && (
            <div className='d-flex justify-content-center align-items-center mt-2'>
              <Button
                size='sm'
                variant='info'
                onClick={() => {
                  setIsPagination(true)
                  setAfter(data.transportList.pageInfo.endCursor)
                }}
              >
                Cargar más volquetas
              </Button>
            </div>
          )}
          {/* {isLoading && <UsersListLoading />} */}
        </KTCardBody>
      </KTCard>

      <Modal show={showModalCreateUpdate} onHide={handleClose}>
        <BootstrapForm onSubmit={formik.handleSubmit}>
          <Modal.Header closeButton>
            <Modal.Title>{idClientEdit ? 'Editar' : 'Crear'} volqueta</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Container className='d-flex flex-column gap-4'>
              <BootstrapForm.Group controlId='plate'>
                <BootstrapForm.Label>Placa:</BootstrapForm.Label>
                <BootstrapForm.Control
                  type='text'
                  placeholder='Ingrese placa'
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.plate}
                  isInvalid={formik.touched.plate && !!formik.errors.plate}
                />
                <BootstrapForm.Control.Feedback type='invalid'>
                  {formik.errors.plate}
                </BootstrapForm.Control.Feedback>
              </BootstrapForm.Group>
              <BootstrapForm.Group controlId='sizeVolco'>
                <BootstrapForm.Label>Capacidad de carga</BootstrapForm.Label>
                <BootstrapForm.Control
                  type='text'
                  placeholder='Ingrese capacidad del volco'
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.sizeVolco}
                  isInvalid={formik.touched.sizeVolco && !!formik.errors.sizeVolco}
                />
                <BootstrapForm.Control.Feedback type='invalid'>
                  {formik.errors.sizeVolco}
                </BootstrapForm.Control.Feedback>
              </BootstrapForm.Group>
              <BootstrapForm.Group controlId='description'>
                <BootstrapForm.Label>Descripción:</BootstrapForm.Label>
                <BootstrapForm.Control
                  as='textarea'
                  rows={3}
                  placeholder='Ingrese descripción'
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.description}
                  isInvalid={formik.touched.description && !!formik.errors.description}
                />
                <BootstrapForm.Control.Feedback type='invalid'>
                  {formik.errors.description}
                </BootstrapForm.Control.Feedback>
              </BootstrapForm.Group>
            </Container>
          </Modal.Body>
          <Modal.Footer>
            <Button
              type='button'
              variant='secondary'
              onClick={() => {
                handleClose()
                setIdClientEdit(null)
                formik.resetForm()
              }}
            >
              Cancelar
            </Button>
            <Button
              type='submit'
              variant='primary'
              disabled={loadingCreate}
              className='d-flex align-items-center gap-2'
            >
              {loadingCreate && <Spinner color='light' size='14px' />}
              {/* <Spinner color='light' size='14px' /> */}
              {idClientEdit ? 'Editar' : 'Agregar'} volqueta
            </Button>
          </Modal.Footer>
        </BootstrapForm>
      </Modal>
    </div>
  )
}
